import { render, staticRenderFns } from "./account.vue?vue&type=template&id=7f283f8d&scoped=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"
import style0 from "./account.vue?vue&type=style&index=0&id=7f283f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f283f8d",
  null
  
)

export default component.exports